import React from 'react'
import { useAppSelector } from '../hooks/redux'

type Props = {}

export function FavoritePage({}: Props) {
    const {favorites} = useAppSelector(state => state.github)

    if(favorites.length === 0) return <p className='text-center'>Пусто</p>

  return (
    <div className='flex justify-center pt-10 mx-auto h-screen w-screen'>
           <ul className='list-none border py-3 px-4 rounded mb-2 hover:shadow-md hover: bg-gray-100'>
        {
            favorites.map(f =>(
                <li key={f}>
                    <a href={f} target="_blank">{f}</a>
                </li>
            ))

        }
   </ul>
    </div>

  )
}